export const blueColor = '#4182eb';
export const blueOpacityColor = 'rgba(0, 181, 255, 0.0632)';
export const whiteColor = '#ffffff';
export const orangeColor = '#ff8351';
export const lightGreyColor = 'rgba(0, 0, 0, 0.25)';
export const layoutBackgroundColor = '#F2F2F8';
export const weightGreyColor = 'rgba(247, 247, 251, 1)';
export const lightBlackColor = '#D7D7DE';
export const weightBlackColor = 'rgba(72, 72, 102, 0.92)';
export const middleBlackColor = '#484866eb';
export const tableShortBorderColor = 'rgba(216, 216, 216, 1)';
export const transparentColor = 'transparent';
export const titleColor = 'rgba(72, 72, 102, 0.92)';
export const contentFontColor = '#484866eb';
export const lightFontColor = 'rgb(178,178,178)';
export const borderColor = '#D7D7DE';
export const defaultBorder = `1px solid ${borderColor}`;
export const defaultBorderRadius = 6;
export const backgroundColor = '#f2f2f8';
export const defaultFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"';


// linear
export const whiteGreyLinearColor = `linear-gradient(180deg,
  rgba(250, 250, 250, 1) 0%,
  rgba(245, 245, 245, 1) 100%
)`;

export const blueLightLinearColor = `linear-gradient(108deg,rgba(0,158,249,1) 0%,rgba(28,196,248,1) 100%)`;

// default values
export const defaultSelectWidth = 200;
export const defaultSelectListHeight = 200;

export const defaultInputHeight = 32;
export const defaultLineHeight = 40;
